import QueryParamsBuilder from "components/helpers/commonFunctions/QueryParamsBuilder";
import { uploadBankFileApiUrls } from "constants/apiEndPoints";
import { type BankFileRecordType } from "pages/UploadDetails/UploadDetailsGrid";
import type { UploadFileType } from "pages/Uploads";
import type { UploadCustomerFilesType } from "pages/Uploads/CustomerBankFile";
import type { UploadFilesType } from "pages/Uploads/UploadFile";
import ApiUtils from "utils/ApiUtil";

const createAnduploadBankFile = async (contributionFile: UploadFilesType, empId: number): Promise<string> => {
    const formData = new FormData();
    formData.append('file', contributionFile.file);
    const assignedList = await ApiUtils.postWithToken(`${uploadBankFileApiUrls.createBankFiles}/${empId}`, formData) as string;
    return assignedList;
};

const createCustomerBankFile = async (contributionFile: UploadCustomerFilesType, empId: number): Promise<string> => {
    const formData = new FormData();
    formData.append('file', contributionFile.file);
    formData.append('userId', String(contributionFile.userId));
    const assignedList = await ApiUtils.postWithToken(`${uploadBankFileApiUrls.createFileUploadForCustomer}/${empId}`, formData) as string;
    return assignedList;
};
const getUploadedBankFiles = async (page: number, size: number, sortBy: string, sortOrder: string, searchValue: string, filters: unknown): Promise<UploadFileType[]> => {

    let url = QueryParamsBuilder({ baseUrl: `${uploadBankFileApiUrls.getBankFiles}`, page, size, sortBy, sortOrder, searchValue });

    const filterParams = new URLSearchParams();
    if (filters) {
        if (filters.startDate) {
            filterParams.append('startDate', filters.startDate);
        }
        if (filters.endDate) {
            filterParams.append('endDate', filters.endDate);
        }
    }

    if (filterParams.toString()) {
        url += `&${filterParams.toString()}`;
    }

    const assignedList = await ApiUtils.getWithToken(url) as UploadFileType[];
    return assignedList;
}

const downloadBankFiles = async (key: string, fileName: string): Promise<UploadFileType[]> => {
    const assignedList = await ApiUtils.postWithToken(uploadBankFileApiUrls.downloadBankFiles, { key, fileName }) as UploadFileType[];
    return assignedList;
}

const getBankTransactionFile = async (startDate: string, endDate: string): Promise<unknown> => {
    return await new Promise((resolve, reject) => {
        let url = `${uploadBankFileApiUrls.getBankTransactionFile}`;
        const filterParams = new URLSearchParams();

        if (startDate) {
            filterParams.append('startDate', startDate);
        }
        if (endDate) {
            filterParams.append('endDate', endDate);
        }

        if (filterParams.toString()) {
            url += `?${filterParams.toString()}`
        }

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ApiUtils.getExcelFile(url).then((res: any) => {
            const blob = new Blob([res.data], { type: res.headers['content-type'] });
            const url = URL.createObjectURL(blob);
            resolve(url);
        }).catch((error) => {
            reject(error)
        });
    });
}

const getOrganizationsListByName = async (value: string): Promise<unknown> => {
    const orgaizationsList = await ApiUtils.getWithToken(`${uploadBankFileApiUrls.getOrganizationsListUrl}?name=${value}`)
    return orgaizationsList;
}

const getBankFileRecordsById = async (id: string, page: number, size: number): Promise<BankFileRecordType> => {
    const recordList = await ApiUtils.getWithToken(`${uploadBankFileApiUrls.getBankFilesById}/${id}?page=${page}&size=${size}`) as BankFileRecordType;
    return recordList;
}

const updateBankRecordFileStatus = async (id: number, status: string): Promise<unknown> => {
    const result = await ApiUtils.putWithToken(`${uploadBankFileApiUrls.updateBankRecordFileStatus}/${id}`, { status });
    return result;
}

const getBankFileRecordsByStatus = async (status: string, page: number, size: number, sortBy: string, sortOrder: string, searchValue: string): Promise<BankFileRecordType> => {

    const url = QueryParamsBuilder({ baseUrl: uploadBankFileApiUrls.getBankFilesByStatus, page, size, sortBy, sortOrder, searchValue });

    const recordList = await ApiUtils.postWithToken(url, { status }) as BankFileRecordType;
    return recordList;
}

const updateTransactionNarrativeForReconcile = async (id: number, transactionNarrative: string): Promise<unknown> => {
    const result = await ApiUtils.putWithToken(`${uploadBankFileApiUrls.updateBankFileManualReconcile}/${id}`, { transactionNarrative });
    return result;
}

const getManualReconcileBankFileRecords = async (id: string): Promise<BankFileRecordType> => {
    const recordList = await ApiUtils.getWithToken(`${uploadBankFileApiUrls.getManualBankRecordFileByBankRecordFileId}/${id}`) as BankFileRecordType;
    return recordList;
}


export {
    createAnduploadBankFile,
    getUploadedBankFiles,
    downloadBankFiles,
    createCustomerBankFile,
    getOrganizationsListByName,
    getBankFileRecordsById,
    updateBankRecordFileStatus,
    getBankFileRecordsByStatus,
    updateTransactionNarrativeForReconcile,
    getManualReconcileBankFileRecords,
    getBankTransactionFile
}